import type { WizardColor } from "@ui/types/wizard";
import { createContext, type ReactNode, useContext } from "react";

export type { WizardColor };

export interface WizardContextValue {
  color: WizardColor;
  currentStage: number;
  totalStages: number;
}

/** Shared shape for the three slot-button props (`Wizard.PrimaryButton`,
 *  `Wizard.SecondaryButton`, `Wizard.TertiaryButton`). Each slot extends this
 *  with its own extras (e.g. `isPending` on primary, `placement` on secondary). */
export interface WizardActionButtonProps {
  children: ReactNode;
  /** Mobile-only label override. Falls back to `children` when omitted. */
  mobileLabel?: string;
  /** When set, mobile renders icon-only. `mobileLabel` becomes the `aria-label`. */
  mobileIcon?: ReactNode;
  leadIcon?: ReactNode;
  trailIcon?: ReactNode;
  href?: string;
  onPress?: () => void;
  isDisabled?: boolean;
}

export const WizardContext = createContext<WizardContextValue | null>(null);

export function useWizardContext(): WizardContextValue {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error("Wizard slot components must be rendered inside <Wizard>.");
  return ctx;
}
